import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        //'http://127.0.0.1:8000/document/api/v1/login/',
             'https://doc.teamhalt.com/document/api/v1/login/',
           formData
      );

      const { user, access, refresh } = response.data;

      localStorage.setItem('id', user.id);
      localStorage.setItem('email', user.email);
      localStorage.setItem('name', user.first_name + ' ' + user.last_name);
      localStorage.setItem('role', user.role);
      localStorage.setItem('contact_number', user.contact_number);
      localStorage.setItem('accessToken', access);
      localStorage.setItem('refreshToken', refresh);
      localStorage.setItem(
        'user_permissions',
        JSON.stringify(user.user_permissions)
      );

      if (['admin', 'subadmin', 'manager', 'user'].includes(user.role_name)) {
        navigate('/admin-dashboard');
      }
    } catch (error) {
      console.error('Login error:', error.response ? error.response.data : error);
      setError('Login failed. Please check your credentials.');
    }
  };

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  return (
    <div className="login-wrapper">
      <div className="login-card">
        {/* Left side: Logo + Heading + Welcome */}
        <div
          className="card-left"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px',
            textAlign: 'center',
          }}
        >
          <img
            src="/logo.png"
            alt="TeamHalt Logo"
            className="card-logo"
            style={{ width: '60px', marginBottom: '10px', borderRadius: '10px' }}
          />
          <h2
            className="brand-name"
            style={{
              fontWeight: '600',
              fontSize: '20px',
              color: '#fff',
              marginBottom: '15px',
            }}
          >
            TEAMHALT PRIVATE LIMITED
          </h2>
          <p
            className="welcome-text"
            style={{ color: '#555', fontSize: '15px', marginTop: '10px' }}
          >
            Welcome to Teamhalt Document Manager
          </p>
        </div>

        {/* Right side: Login Form */}
        <div className="card-right">
          <h2>Login</h2>
          <form onSubmit={handleSubmit} className="login-form">
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <div className="password-field">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <span
                className={`toggle-password ${showPassword ? 'show' : ''}`}
                onClick={togglePasswordVisibility}
              >
                <i
                  className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                  style={{
                    cursor: 'pointer',
                    transform: 'translateY(-50%)',
                    color: '#000',
                  }}
                ></i>
              </span>
            </div>

            {error && <p className="error-message">{error}</p>}

            <button type="submit" className="login-btn">
              Login
            </button>

            <p className="forgot-password">
              <a href="/forgot-password">Forgot Password?</a>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
